var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('h3',[_vm._v("Your request has been submitted.")]),_c('p',[_vm._v("Confirmation will be sent to "+_vm._s(this.user.primary_email)+".")])])}
var staticRenderFns = []

export { render, staticRenderFns }